import axios from "axios";
import axiosInstance from "../lib/axiosInstance";
const baseUrl = process.env.REACT_APP_API_URL + '/admin'

const UsersModel=class {

    async profile() {
        //axiosInstance.defaults.headers.common['Authorization'] = "Bearer "+localStorage.getItem("access_token");
        return (await axiosInstance.get(`${baseUrl}/profile`)).data?.data || null;
    }

    async getAllUsers() {
        //axiosInstance.defaults.headers.common['Authorization'] = "Bearer "+localStorage.getItem("access_token");
        return (await axiosInstance.get(`${baseUrl}/users`)).data || null;
    }

    async getSpecificUser(userId = ''){
        const res = await axiosInstance.get(`${baseUrl}/users/${userId}`)
        return res?.data
    }

    async updateProfile(data=[])
    {
        return await axiosInstance.put(`${baseUrl}/update_profile`,data);
    }

    async getBookingDetails(query = ''){
        const response = (await axiosInstance.get(`${baseUrl}/bookings?id=${query}`)).data
        return response;
    }

    async getSpecificUserBookings(userId = ''){
       return (await axiosInstance.get(`${baseUrl}/bookings/${userId}`)).data
    }

    async getSupport(query = ''){
        return (await axiosInstance.get(`${baseUrl}/support?id=${query}`)).data
        // return (await axiosInstance.get(`${baseUrl}/support`)).data
    }

    async updateSupport(id, data = {}){
        return await axiosInstance.put(`${baseUrl}/support/${id}`,data);
    }

    async deleteSupport(id){
        return await axiosInstance.delete(`${baseUrl}/support/${id}`);
    }

    async getFeedback(){
        return (await axiosInstance.get(`${baseUrl}/reviews`)).data
    }

    async deleteFeedback(id){
        return await axiosInstance.delete(`${baseUrl}/reviews/${id}`);
    }
    async editUserDetails(formData=[], id) {
        const data = await axiosInstance.put(baseUrl+"/user/"+id, formData);
        return data;
    }

    async transactionsDetails(id) {
        const data = await axiosInstance.get(baseUrl+"/transactions/"+id);
        return data;
    }

    async deleteTransaction(id) {
        const data = await axiosInstance.delete(baseUrl+"/transactions/"+id);
        return data;
    }

}

export default new UsersModel();